import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../utils/api.js';

export const useGatePasses = (params = {}) =>
  useQuery({
    queryKey: ['gate-passes', params],
    queryFn: () => api.get('/gate-passes', { params }).then(r => r.data.data),
  });

export const useGatePass = (id) =>
  useQuery({
    queryKey: ['gate-passes', id],
    queryFn: () => api.get(`/gate-passes/${id}`).then(r => r.data.data),
    enabled: !!id,
  });

export const useCreateGatePass = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post('/gate-passes', data).then(r => r.data.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['gate-passes'] }),
  });
};

export const useUpdateGatePass = (id) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.put(`/gate-passes/${id}`, data).then(r => r.data.data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['gate-passes'] }); qc.invalidateQueries({ queryKey: ['gate-passes', id] }); },
  });
};

export const useTransitionGatePass = (id) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post(`/gate-passes/${id}/transition`, data).then(r => r.data.data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['gate-passes'] }); qc.invalidateQueries({ queryKey: ['gate-passes', id] }); },
  });
};
